import { useEffect, useState } from "react";
import { notification } from "antd";
import { AssessmentTemplateHttpService } from "@/modules/assessments/services/assessment-template-http.service";

export interface IAssessmentTemplate {
  templateId: number;
  name: string;
  isClientSpecific?: boolean;
  landingImageUrl?: string;
  landingText?: Record<string, string>;
  // Locales offered by every preset test in the template (intersection of their availableLocales).
  supportedLocales?: string[];
}

export interface IAssessmentTemplateOption {
  value: number | string;
  label: string;
  disabled?: boolean;
  landingImageUrl?: string;
  landingText?: Record<string, string>;
  supportedLocales?: string[];
}

export function useAssessmentTemplatesHook(clientId: number | undefined) {
  const [templates, setTemplates] = useState<IAssessmentTemplateOption[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!clientId) {
      setIsLoading(false);
      return;
    }

    (async () => {
      try {
        setIsLoading(true);
        const assessmentTemplates = await AssessmentTemplateHttpService.getLatestActiveTemplates(clientId);
        const mappedTemplates: IAssessmentTemplateOption[] = assessmentTemplates.map(
          (template: IAssessmentTemplate) => ({
            value: template.templateId,
            label: template.name,
            landingImageUrl: template.landingImageUrl,
            landingText: template.landingText,
            supportedLocales: template.supportedLocales,
          }),
        );
        setTemplates(mappedTemplates);
        setIsLoading(false);
      } catch (e: any) {
        console.error(`assessment templates error: ${e}`);
        notification.error({
          message: "Failed to load assessment templates",
        });
        setIsLoading(false);
      }
    })();
  }, [clientId]);

  return { templates, isLoading };
}
